<template>
	<div class="pageBox">
		<Header :current="current" ref="Header"></Header>
		<div class="pageBox_cen">

			<div class="account-content">
				<div class="account-inner">
					<indexTitle :title="title" :more="false" mabot="20px"></indexTitle>
					<p class="account-subtitle" v-if="subtitle">{{ subtitle }}</p>
					<div class="account-form-box" :class="{ wide: wide }">
						<slot></slot>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from "@/components/header.vue"
import Footer from "@/components/footer.vue"
import indexTitle from "@/components/c/indexTitle.vue"
export default {
	components: { Header, Footer, indexTitle },
	props: {
		title: { type: String, default: '' },
		subtitle: { type: String, default: '' },
		current: { type: String, default: '' },
		wide: { type: Boolean, default: false }
	},
	data() {
		return {
			navHidden: false,
			lastScrollTop: 0,
		}
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
		var element;
		if (this.nowVibe == 'pc') {
			element = document.documentElement
		} else {
			element = document.documentElement.scrollTop ? document.documentElement : document.body;
		}
		let scrollTop = element.scrollTop;
		try {
			if (scrollTop == 0) {
				this.$refs.Header.headerHover = false;
				this.$refs.Header.headerTrue = false;
			} else {
				this.$refs.Header.headerTrue = true;
				this.$refs.Header.headerHover = true;
			}
		} catch (e) {
			//TODO handle the exception
		}
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		handleScroll() {
			const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			if (currentScrollTop > this.lastScrollTop) {
				this.navHidden = true;
			} else {
				this.navHidden = false;
			}
			this.lastScrollTop = currentScrollTop;
			try {
				if (currentScrollTop == 0) {
					if (!this.$refs.Header.navHead) {
						this.$refs.Header.headerHover = false;
					}
					this.$refs.Header.headerTrue = false;
				} else {
					this.$refs.Header.headerTrue = true;
					this.$refs.Header.headerHover = true;
				}
			} catch (e) {
				//TODO handle the exception
			}
		},
	}
}
</script>

<style scoped lang="scss">
.pageBox {
	display: flex;
	flex-direction: column;
	min-height: 100vh;

	.pageBox_cen {
		flex: 1;
		padding-top: 10px;
	}
}

.account-banner {
	width: 100%;
	height: 420px;
	background: linear-gradient(135deg, #1a1a1a 0%, #3d3d3d 100%);
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;

	.banner-title {
		font-size: 48px;
		font-weight: bold;
		color: #FFFFFF;
		letter-spacing: 4px;
		text-align: center;
	}
}

.account-content {
	width: 100%;
	background: #FFFFFF;
	padding: 80px 20px 100px;
	box-sizing: border-box;
}

.account-inner {
	max-width: 1200px;
	width: 100%;
	margin: 0 auto;
}

.account-subtitle {
	font-size: 15px;
	color: #666666;
	line-height: 1.6;
	margin: 0 0 48px;
}

.account-form-box {
	max-width: 560px;
	margin: 0 auto;
	padding: 40px;
	background: #FFFFFF;
	border: 1px solid #E5E5E5;
	border-radius: 2px;

	&.wide {
		max-width: 680px;
	}

	::v-deep .el-form-item {
		margin-bottom: 24px;
	}

	::v-deep .el-form-item__label {
		color: #000000;
		font-weight: 500;
		font-size: 14px;
		line-height: 44px;
	}

	::v-deep .el-input__inner {
		border-radius: 0;
		height: 44px;
		line-height: 44px;
		border-color: #DCDCDC;
		color: #000000;

		&:focus {
			border-color: #000000;
		}
	}

	::v-deep .el-input__suffix {
		right: 10px;
	}
}

@media screen and (max-width: 1200px) {
	.account-banner {
		height: 320px;

		.banner-title {
			font-size: 32px;
			letter-spacing: 2px;
		}
	}

	.account-content {
		padding: 50px 20px 70px;
	}

	.account-subtitle {
		margin-bottom: 30px;
	}

	.account-form-box {
		padding: 30px;
	}
}

@media screen and (max-width: 768px) {
	.account-banner {
		height: 260px;

		.banner-title {
			font-size: 26px;
			letter-spacing: 1px;
		}
	}

	.account-content {
		padding: 40px 16px 60px;
	}

	.account-form-box {
		padding: 24px 20px;
		max-width: 100%;
	}
}
</style>
